import axios from 'axios'
import { cloneDeep, isFunction, merge } from 'lodash'

import { RequestMethodsEnum } from '@/enums/requestEnums'

import axiosCancel from './cancel'
import store from '@/store'
import router from '@/router'
console.log(router,'routerrouterrouterrouter')
console.log(store,'store13123552522')

// 设备类型
const deviceType = store.state?.device?.deviceType

export class Axios {
  constructor(config) {
    console.log(config,'configconfigconfigconfigconfig999999999');
    this.config = config
    this.options = config.requestOptions
    this.axiosInstance = axios.create(config)
    this.setupInterceptors()
  }

  /**
   * @description 获取axios实例
   */
  getAxiosInstance() {
    return this.axiosInstance
  }

  /**
   * @description 设置拦截器
   */
  setupInterceptors() {
    if (!this.config.axiosHooks) {
      return
    }
    const {
      requestInterceptorsHook,
      requestInterceptorsCatchHook,
      responseInterceptorsHook,
      responseInterceptorsCatchHook
    } = this.config.axiosHooks
    this.axiosInstance.interceptors.request.use(
      (config) => {
        this.addCancelToken(config)
        if (isFunction(requestInterceptorsHook)) {
          config = requestInterceptorsHook(config)
        }
        return config
      },
      (err) => {
        if (isFunction(requestInterceptorsCatchHook)) {
          requestInterceptorsCatchHook(err)
        }
        return err
      }
    )
    this.axiosInstance.interceptors.response.use(
      async (response) => {
        console.log(response,'responseresponseresponseresponseresponse');
        this.removeCancelToken(response.config.url)

        // 处理 token 失效的情况
      if (response.data && response.data.code === -1) {
        store.dispatch("user/resetUserInfo");
        // if (deviceType === 'mobile') {
        //   await router.replace('/mobile/login')
        // } else {
        //   await router.replace('/pc/logIn')
          
        // }
         // 返回 Promise.reject，中断后续操作
      return Promise.reject(response.data)
      }
        if (isFunction(responseInterceptorsHook)) {
          response = responseInterceptorsHook(response)
        }
        console.log(response,'responseresponseresponseresponseresponse123465468798');
        return response
      },
      (err) => {
        if (isFunction(responseInterceptorsCatchHook)) {
          responseInterceptorsCatchHook(err)
        }
        // if (err.code != AxiosError.ERR_CANCELED) {
        //   this.removeCancelToken(err.config?.url)
        // }

        // if (err.code == AxiosError.ECONNABORTED || err.code == AxiosError.ERR_NETWORK) {
        //   return new Promise((resolve) => setTimeout(resolve, 500)).then(() =>
        //     this.retryRequest(err)
        //   )
        // }
        return Promise.reject(err)
      }
    )
  }

  /**
   * @description 添加CancelToken
   */
  addCancelToken(config) {
    const { ignoreCancelToken } = config.requestOptions
    !ignoreCancelToken && axiosCancel.add(config)
  }

  /**
   * @description 移除CancelToken
   */
  removeCancelToken(url) {
    axiosCancel.remove(url)
  }

  /**
   * @description 重新请求
   */
  retryRequest(error) {
    const config = error.config
    const { retryCount, isOpenRetry } = config.requestOptions
    if (!isOpenRetry || config.method?.toUpperCase() == RequestMethodsEnum.POST) {
      return Promise.reject(error)
    }
    config.retryCount = config.retryCount ?? 0

    if (config.retryCount >= retryCount) {
      return Promise.reject(error)
    }
    config.retryCount++

    return this.axiosInstance.request(config)
  }
  /**
   * @description get请求
   */
  get(config, options) {
    return this.request({ ...config, method: RequestMethodsEnum.GET }, options)
  }

  /**
   * @description post请求
   */
  post(config, options) {
    return this.request({ ...config, method: RequestMethodsEnum.POST }, options)
  }

  /**
   * @description 请求函数
   */
  request(config, options) {
    const opt = merge({}, this.options, options)
    const axioxConfig = {
      ...cloneDeep(config),
      requestOptions: opt
    }
    const { urlPrefix } = opt
    // 拼接请求前缀如api
    if (urlPrefix) {
      axioxConfig.url = `${urlPrefix}${config.url}`
    }
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .request(axioxConfig)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
} 